export const GetAllProjects = `
query GetAllProjects(
    $tags: [Int],
    $traits:[String]
    $uids: [Int],
    $page: Int,
    $perpage: Int
    $search: String,
    $orderby: OrderByEnum,
){
    homeposts(tags: $tags, page: $page, perpage: $perpage, uids: $uids, traits: $traits, search: $search, orderby: $orderby){
      posts{
            creatoruid
            postid
            dateupdated
            postthumbnail
            published
            active
            title
            postmobilecover
            postthumbnailcover
            contenttime
            creator {
                profilepicture
                occupationtitle,
                uid,
                alias
            }

            tags {
                tagid
                name
                tagtype {
                    internalname
                }
            }

            traits {
                name
                internalname
            }

        }
        totalCount
        pageCount
        page
    }
  }
`;
